import { createContext, useContext, useState, ReactNode } from 'react';

interface CookieConsentContextType {
  showSettings: boolean;
  openCookieSettings: () => void;
  closeCookieSettings: () => void;
}

const CookieConsentContext = createContext<CookieConsentContextType>({
  showSettings: false,
  openCookieSettings: () => {},
  closeCookieSettings: () => {},
});

export const useCookieConsent = () => {
  const context = useContext(CookieConsentContext);
  if (!context) {
    throw new Error('useCookieConsent must be used within CookieConsentProvider');
  }
  return context;
};

interface CookieConsentProviderProps {
  children: ReactNode;
}

export const CookieConsentProvider = ({ children }: CookieConsentProviderProps) => {
  const [showSettings, setShowSettings] = useState(false);

  const openCookieSettings = () => {
    setShowSettings(true);
  };

  const closeCookieSettings = () => {
    setShowSettings(false);
  };

  return (
    <CookieConsentContext.Provider 
      value={{ showSettings, openCookieSettings, closeCookieSettings }}
    >
      {children}
    </CookieConsentContext.Provider>
  );
};
